// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-AppPreview-module__appPreview-SNes1 {
  position: relative;
  width: 100%;
  background: var(--background-secondary);
}

.nightbot-AppPreview-module__appPreview-SNes1::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.4;
  z-index: -1;
}

.nightbot-AppPreview-module__image-KQlpu {
  border: 6px solid var(--mantine-color-gray-10);
  outline: 1px solid var(--mantine-color-gray-6);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--mantine-shadow-xl);
}

.nightbot-AppPreview-module__hidden-RAhQd {
  display: none;
}

.nightbot-AppPreview-module__controls-raApJ {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  gap: 16px;
}

.nightbot-AppPreview-module__title-BW4KB {
  font-size: 32px;
  margin-bottom: 16px;
}

.nightbot-AppPreview-module__description-LbYPD {
  max-width: 600px;
  margin-bottom: 64px;
}

.nightbot-AppPreview-module__panelContainer-db_hV {
  position: relative;
}

.nightbot-AppPreview-module__paginationDot-Btc5s {
  height: 100%;
  background-color: var(--mantine-color-gray-3);
  transform-origin: left;
  transform: scaleX(0);
}

.nightbot-AppPreview-module__paginationDotContainer-u3CPX {
  height: 6px;
  border-radius: var(--mantine-radius-lg);
  background-color: var(--mantine-color-gray-8);
  overflow: hidden;
  width: 24px;
  cursor: pointer;
}

.nightbot-AppPreview-module__imageContainer-XGjb1 {
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/AppPreview.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,6CAA6C;EAC7C,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".appPreview {\n  position: relative;\n  width: 100%;\n  background: var(--background-secondary);\n}\n\n.appPreview::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 40%;\n  z-index: -1;\n}\n\n.image {\n  border: 6px solid var(--mantine-color-gray-10);\n  outline: 1px solid var(--mantine-color-gray-6);\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: var(--mantine-shadow-xl);\n}\n\n.hidden {\n  display: none;\n}\n\n.controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 32px;\n  gap: 16px;\n}\n\n.title {\n  font-size: 32px;\n  margin-bottom: 16px;\n}\n\n.description {\n  max-width: 600px;\n  margin-bottom: 64px;\n}\n\n.panelContainer {\n  position: relative;\n}\n\n.paginationDot {\n  height: 100%;\n  background-color: var(--mantine-color-gray-3);\n  transform-origin: left;\n  transform: scaleX(0);\n}\n\n.paginationDotContainer {\n  height: 6px;\n  border-radius: var(--mantine-radius-lg);\n  background-color: var(--mantine-color-gray-8);\n  overflow: hidden;\n  width: 24px;\n  cursor: pointer;\n}\n\n.imageContainer {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appPreview": `nightbot-AppPreview-module__appPreview-SNes1`,
	"image": `nightbot-AppPreview-module__image-KQlpu`,
	"hidden": `nightbot-AppPreview-module__hidden-RAhQd`,
	"controls": `nightbot-AppPreview-module__controls-raApJ`,
	"title": `nightbot-AppPreview-module__title-BW4KB`,
	"description": `nightbot-AppPreview-module__description-LbYPD`,
	"panelContainer": `nightbot-AppPreview-module__panelContainer-db_hV`,
	"paginationDot": `nightbot-AppPreview-module__paginationDot-Btc5s`,
	"paginationDotContainer": `nightbot-AppPreview-module__paginationDotContainer-u3CPX`,
	"imageContainer": `nightbot-AppPreview-module__imageContainer-XGjb1`
};
export default ___CSS_LOADER_EXPORT___;
